import { useEffect, useState } from 'react';
import { Brain, Database, CheckCircle, FileText, Sparkles } from 'lucide-react';
import styles from './ThinkingAnimation.module.css';

const STAGES = [
  { icon: Brain, label: 'Analyzing your request...', duration: 2000 },
  { icon: Database, label: 'Searching our provider database...', duration: 4000 },
  { icon: CheckCircle, label: 'Evaluating provider matches...', duration: 6000 },
  { icon: FileText, label: 'Generating your quotation...', duration: Infinity },
] as const;

interface ThinkingAnimationProps {
  isPending: boolean;
}

export function ThinkingAnimation({ isPending }: ThinkingAnimationProps) {
  const [stageIndex, setStageIndex] = useState(0);

  useEffect(() => {
    if (!isPending) {
      setStageIndex(0);
      return;
    }

    setStageIndex(0);
    const timers: ReturnType<typeof setTimeout>[] = [];
    let elapsed = 0;

    STAGES.forEach((stage, i) => {
      if (stage.duration === Infinity) return;
      elapsed += stage.duration;
      const t = setTimeout(() => setStageIndex(i + 1), elapsed);
      timers.push(t);
    });

    return () => timers.forEach(clearTimeout);
  }, [isPending]);

  if (!isPending) return null;

  const stage = STAGES[Math.min(stageIndex, STAGES.length - 1)];
  const Icon = stage.icon;

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar}>
        <Sparkles size={14} />
      </div>
      <div className={styles.bubble}>
        <span className={styles.iconWrapper}>
          <Icon size={16} className={styles.icon} />
        </span>
        <span className={styles.label}>{stage.label}</span>
        <span className={styles.dots}>
          <span />
          <span />
          <span />
        </span>
      </div>
    </div>
  );
}
